import { Types as AppTypes } from '../../actions/app'
import { Types } from '../../actions/dashboards'
import { Metrics } from '../../constants/Dashboards'
import { ArrayUtils } from '../../utils'
import initialState from './initialState'
import reducers from './reducers'

export default (state = initialState, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case 'persist/REHYDRATE':
        case AppTypes.SELECT_ESTATE: {
            return {
                ...initialState,
            }
        }
        case Types.DASHBOARD_EVENTSPACE_FETCH_PRODUCTS.success: {
            const products = payload?.data?.getProducts || []
            const { stats } = state
            const { [Metrics.EVENTSPACE_PRODUCTS_TOP]: oldList = [] } = stats

            const newList = oldList.map((entry) => {
                const { sku } = entry
                const productIndex = products.findIndex(({ sku: productSku }) => sku === productSku)

                if (productIndex === -1) {
                    return entry
                }

                const { images, title: name } = products[productIndex] || {}
                return {
                    ...entry,
                    sku,
                    image: images[0]?.url,
                    name,
                }
            })

            return {
                ...state,
                stats: {
                    ...state.stats,
                    [Metrics.EVENTSPACE_PRODUCTS_TOP]: newList,
                },
            }
        }
        case Types.DASHBOARD_FETCH_STORE.success: {
            // Get store data from payload
            const { code, name } = payload

            /**
             * Function to update stores in every state array its key is provided
             * @param {Array<String>} arrayNames State keys
             */
            const updateArrays = (arrayNames = []) => {
                // For every state array key
                const stats = arrayNames.reduce((carryState, arrayName) => {
                    // Get the array
                    const { [arrayName]: oldArray = [] } = carryState

                    // Find the index of the store record
                    const oldEntryIndex = oldArray.findIndex(({ storeCode }) => storeCode === code)

                    // If no entry with that store code, just quit (return the same state)
                    if (oldEntryIndex === -1) {
                        return carryState
                    }

                    // Enhance the found record's data
                    const newArray = ArrayUtils.insertItem(oldArray, oldEntryIndex, {
                        ...oldArray[oldEntryIndex],
                        storeName: name,
                    })

                    // Return the updated state
                    return {
                        ...carryState,
                        [arrayName]: newArray,
                    }
                }, state.stats)

                // If none stat has been updated, return same state
                if (stats === state.stats) {
                    return state
                }

                // Update stats
                return {
                    ...state,
                    stats,
                }
            }

            return updateArrays([
                Metrics.ARK_TOP_STORES,
                Metrics.EVENTSPACE_STORES_TOP,
                Metrics.INRUN_STORES_TOP,
                Metrics.LARGEVISION_STORES_TOP,
                Metrics.LIFTLEARN_TOP_STORES,
                Metrics.MINIVISION_STORES_TOP,
                Metrics.WFH_STORES_TOP,
                Metrics.WOW_STORES_TOP,
                Metrics.EVENTSPACE_STORES_TOP,
            ])
        }
        default:
            return reducers.reduce((carry, reducer) => carry || reducer(state, { type, payload, meta }), null) || state
    }
}
